<template>
    <div>
        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin:PagePrivacy -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ titleinfo[getCurrentLocale] }}</h1>
                        </div>
                        <br />

                        <div class="booking-information sdr-box">
                            <h4 v-html="fare_h4_1[getCurrentLocale]"></h4>
                            <p v-html="fare_p_1[getCurrentLocale]"></p>


                            <br /><h4 v-html="fare_h4_2[getCurrentLocale]"></h4>
                            <p v-html="fare_p_2[getCurrentLocale]"></p>


                            <br /><h4 v-html="fare_h4_3[getCurrentLocale]"></h4>
                            <p v-html="fare_p_3[getCurrentLocale]"></p>


                            <br /><h4 v-html="fare_h4_4[getCurrentLocale]"></h4>
                            <p v-html="fare_p_4[getCurrentLocale]"></p>
                        </div>
                    </div>
                    <!-- End:PagePrivacy -->

                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->


        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Tariff regulations',
                    de: 'Tarifbestimmungen',
                },
                // >>> ------------------------
                fare_h4_1: {
                    en: 'Your Eco Sund Fare conditions',
                    de: 'Ihre Eco Sund Tarifbestimmungen',
                },
                fare_h4_2: {
                    en: 'Rebooking',
                    de: 'Umbuchung',
                },
                fare_h4_3: {
                    en: 'Name change',
                    de: 'Namensänderung',
                },
                fare_h4_4: {
                    en: 'Cancellation',
                    de: 'Stornierung',
                },
                fare_p_1: {
                    en: "For infants under the age of two (2) travelling on their parents' laps, a fixed service fee will be charged for each leg of the journey, amounting to 29 € (50 € on Lebanon flights).<br /><br />Infants under the age of 2 can’t claim a separate seat.<br /><br />If the infant will complete the second year of life before the return flight, a booking as a full paying child(2 - 11 years) with right to a seat is mandatory for safety reasons.<br /><br />For safety reasons, only one(1) infant per adult on board is allowed.",
                    de: 'Kleinkinder unter 2 Jahren, die auf dem Schoß der Eltern reisen, zahlen pro Teilstrecke lediglich eine Servicepauschale von 29 € (50 € auf Libanon-Flügen).<br /><br />Kleinkinder unter 2 Jahren haben keinen Anspruch auf einen Sitzplatz.<br /><br />Aus Sicherheitsgründen ist nur ein(1) Kleinkind pro Erwachsenen an Bord gestattet.<br /><br />Sollte das Kleinkind vor dem Rückflug oder zum Rückreisetermin das 2. Lebensjahr vollenden, so ist aus Sicherheitsgründen eine Buchung als vollzahlendes Kind(2 – 11 Jahre) mit Sitzplatz zwingend erforderlich.',
                },
                fare_p_2: {
                    en: 'Changes to the date of flight are chargeable and subject to seat availability within the current timetable period up to 24 hours prior to the scheduled departure. In case of a rebooking to a higher fare the difference is payable.',
                    de: 'Die Reisedaten (Flugdatum) können bei freien Sitzplatzkapazitäten in der gültigen Flugplanperiode bis 24 Stunden vor Abflug gegen Gebühr und ggf. Zahlung der Tarifdifferenz geändert werden.',
                },
                fare_p_3: {
                    en: 'A name change (without change of date and / or flight route) is possible up to 48 hours prior departure. A fee is payable.',
                    de: 'Eine Namensänderung (ohne Änderung Flugdatum und/oder Flugstrecke) ist bis 48 Stunden vor Abflug gegen Gebühr möglich.',
                },
                fare_p_4: {
                    en: 'In case of cancellation or non-appearance the ticket price is not refundable.',
                    de: 'Bei Stornierung bzw. Nichtantritt ist eine Erstattung des Flugpreises nicht möglich.',
                },
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.6em;
        }
        .booking-information {
            padding: 20px 30px 30px;
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 30px;
            padding-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/infos/fare-conditions/Home.vue